/**
 * Custom Tabs Collection section
 * ---------------------------------------------------------------------------
 * Extracted from sections/custom-tabs-collection.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="custom-tabs-collection"]';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.customtabscollectionInit === 'true') return;
    sectionEl.dataset.customtabscollectionInit = 'true';

    var sectionId = sectionEl.dataset.sectionId;
    const tabButtons = sectionEl.querySelectorAll('.custom-tabs-collection__tab-btn');
    const panels = sectionEl.querySelectorAll('.custom-tabs-collection__panel');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', function () {
        const targetId = btn.getAttribute('data-tab-target');
        if (!targetId) return;

        tabButtons.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        panels.forEach(p => {
          p.classList.remove('is-active');
        });

        const targetPanel = sectionEl.querySelector('#' + targetId);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
